import Cookies from 'js-cookie';
import { BEARER_NAME } from "../../config/constants";

const success = data => Promise.resolve(data);

const query = async (url, fetchParams, { patch, parser = 'json' }) => {
    try {
        const res = await fetch(url, fetchParams);
        if ([200, 201, 304].includes(res.status)) {
            let data;
            try {
                data = await res[parser]();
            } catch (error) {
                data = {};
            }
            // if (data.data && data.user.api_token) {
            //     Cookies.set(BEARER_NAME, data.user.api_token);
            // }
            return success(data);
        } else if ([400, 401, 409, 422, 500].includes(res.status)) {
            if (res.status === 401) {
                window.location.href = '/login';
                return;
            }
            return Promise.reject(await res[parser]());
        }
        throw Error('[API unhandled status]');
    } catch (err) {
        global.console.log(`${JSON.stringify(err)}`);
        throw err;
    }
};

export const makeApiCall = async ({ parser = 'json', ...options }) => {
    if (!options.url) {
        throw Error('URL error!')
    }

    const fetchParams = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            ...Cookies.get(BEARER_NAME) && { 'Authorization': `Bearer ${Cookies.get(BEARER_NAME)}` }
        },
        method: options.method || 'GET',
        ...options.body && { body: (options.body instanceof FormData ? options.body : JSON.stringify(options.body)) },
    };

    if (fetchParams.body instanceof FormData) {
        delete fetchParams.headers['Content-Type'];
    }

    return await query(options.url, fetchParams, {
        patch: options.url,
        parser,
    });
};
